export const ConfigProcess = {
  id: 'config-process',
  title: 'processPortal.titleProcess',
  description: 'processPortal.descriptionProcess',
  countKey: 'processes',
};

export const ConfigReport = {
  id: 'config-report',
  title: 'processPortal.titleReport',
  description: 'processPortal.descriptionReport',
  countKey: 'reports',
};

export const ConfigPermission = {
  id: 'config-permission',
  title: 'processPortal.titlePermission',
  description: 'processPortal.descriptionPermission',
  countKey: 'permissions',
};

export const ConfigList = {
  id: 'config-list',
  title: 'processPortal.titleList',
  description: 'processPortal.descriptionList',
  countKey: 'lists',
};

export const ConfigEntity = {
  id: 'config-entity',
  title: 'processPortal.titleEntity',
  description: 'processPortal.descriptionEntity',
  countKey: 'entities',
};

export const ConfigMenu = {
  id: 'config-menu',
  title: 'processPortal.titleMenu',
  description: 'processPortal.descriptionMenu',
  countKey: 'menus',
};

export default [
  {
    ...ConfigProcess,
  },
  {
    ...ConfigReport,
  },
  {
    ...ConfigList,
  },
  {
    ...ConfigEntity,
  },
  {
    ...ConfigPermission,
  },
  {
    ...ConfigMenu,
  },
];
